// extracted by mini-css-extract-plugin
export var list = "RelatedDocs-module--list--e0790";
export var listItem = "RelatedDocs-module--list-item--217ab";
export var listItemText = "RelatedDocs-module--list-item-text--349a6";
export var related = "RelatedDocs-module--related--68c1a";